import { render, staticRenderFns } from "./DetailGoalsAll.vue?vue&type=template&id=96b6c916&scoped=true&"
import script from "./DetailGoalsAll.vue?vue&type=script&lang=js&"
export * from "./DetailGoalsAll.vue?vue&type=script&lang=js&"
import style0 from "./DetailGoalsAll.vue?vue&type=style&index=0&id=96b6c916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b6c916",
  null
  
)

export default component.exports